import { FillLayerSpecification, LineLayerSpecification } from 'mapbox-gl'
import { observer } from 'mobx-react'
import React from 'react'
import { Layer, Source } from 'react-map-gl'

import { colors } from '@flowwai-frontend/design-system'
import { LocationValue } from '@flowwai-frontend/shared/common-components'

import { useMapsInstanceContext } from '../../hooks/useMapsInstanceContext'
import { MapCoordinates } from '../../types'
import { getGeoJsonBasedOnType } from '../MapBoxMarkers/utils'

interface Props {
   geoShape: LocationValue
}

const MapboxLayers = (props: Props): React.ReactElement => {
   const { geoShape } = props

   const mapsInstance = useMapsInstanceContext()

   const getMarkerCoordinates = (): MapCoordinates[] => {
      switch (geoShape.type) {
         case 'POINT':
            return geoShape.value ? [geoShape.value] : []
         case 'MULTI_POINT':
         case 'LINE':
         case 'POLYGON':
            return geoShape.value ?? []
      }
   }

   const markerCoordinates = getMarkerCoordinates()

   const geoJson = getGeoJsonBasedOnType(geoShape.type, markerCoordinates)

   const shouldRenderRegionFill = geoShape.type === 'POLYGON'
   const shouldRenderLines =
      geoShape.type === 'POLYGON' || geoShape.type === 'LINE'

   const polygonStyle: FillLayerSpecification = {
      id: 'polygon',
      type: 'fill',
      paint: {
         'fill-color': colors['error-200'],
         'fill-opacity': 0.4
      },
      source: ''
   }

   const lineStyle: LineLayerSpecification = {
      id: 'line',
      type: 'line',
      paint: {
         'line-color': colors['error-400'],
         'line-width': 2
      },
      source: ''
   }

   return markerCoordinates.length && mapsInstance.isStylesLoaded ? (
      <Source id='my-data' type='geojson' data={geoJson}>
         {shouldRenderRegionFill ? <Layer {...polygonStyle} /> : null}
         {shouldRenderLines ? <Layer {...lineStyle} /> : null}
      </Source>
   ) : (
      <></>
   )
}

export default observer(MapboxLayers)
